import React from "react";
type BrandMarkProps = {
  className?: string;
};
export function BrandMark({
  className = "h-7 w-7"
}: BrandMarkProps) {
  return <svg viewBox="0 0 32 32" fill="none" className={className} aria-hidden="true" data-id="element-17" data-mp="2rnr2jlstvdmh">
      <circle cx="16" cy="16" r="14" stroke="currentColor" strokeWidth="2" data-id="element-18" data-mp="35n0g0dpnftmr" />
      <line x1="16" y1="2" x2="16" y2="30" stroke="currentColor" strokeWidth="2" data-id="element-19" data-mp="30mcrpzst1qw8" />
      <circle cx="16" cy="16" r="5" fill="#2CC4E8" data-id="element-20" data-mp="3fk544j321z67" />
      <circle cx="16" cy="16" r="1.8" fill="#E2561B" data-id="element-21" data-mp="3fikbiz0awqaz" />
    </svg>;
}